module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [(!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }, {
      key: "item.startDate",
      fn: function(ref) {
        var item = ref.item;

        return [(item.startDateEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'startDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.startDate)) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                staticClass: "input-field mt-3",
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "dense": "",
                  "outlined": ""
                },
                model: {
                  value: (item.startDate),
                  callback: function($$v) {
                    _vm.$set(item, "startDate", $$v)
                  },
                  expression: "item.startDate"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (item.startCal),
            callback: function($$v) {
              _vm.$set(item, "startCal", $$v)
            },
            expression: "item.startCal"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          attrs: {
            "type": "month"
          },
          on: {
            "input": function($event) {
              item.startCal = false
            }
          },
          model: {
            value: (item.startDate),
            callback: function($$v) {
              _vm.$set(item, "startDate", $$v)
            },
            expression: "item.startDate"
          }
        })], 1)], 1)])]
      }
    }, {
      key: "item.endDate",
      fn: function(ref) {
        var item = ref.item;

        return [(item.endDateEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'endDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.endDate)) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
          staticClass: "text-center"
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                staticClass: "input-field mt-3",
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "dense": "",
                  "outlined": ""
                },
                model: {
                  value: (item.endDate),
                  callback: function($$v) {
                    _vm.$set(item, "endDate", $$v)
                  },
                  expression: "item.endDate"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (item.endCal),
            callback: function($$v) {
              _vm.$set(item, "endCal", $$v)
            },
            expression: "item.endCal"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          attrs: {
            "type": "month"
          },
          on: {
            "input": function($event) {
              item.endCal = false
            }
          },
          model: {
            value: (item.endDate),
            callback: function($$v) {
              _vm.$set(item, "endDate", $$v)
            },
            expression: "item.endDate"
          }
        })], 1)], 1)])]
      }
    }, {
      key: "item.onboardKPI",
      fn: function(ref) {
        var item = ref.item;

        return [(item.onboardKPIEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'onboardKPI')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.onboardKPI) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.onboardKPI),
            callback: function($$v) {
              _vm.$set(item, "onboardKPI", $$v)
            },
            expression: "item.onboardKPI"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.actualOnboarded",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          class: {
            'td-bg-red item-edit': item.lowonboardKPI,
            'item-edit': !item.lowonboardKPI
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.actualOnboarded) + "\n        ")])])]
      }
    }, {
      key: "item.achieved",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.achieved) + " %\n      ")])]
      }
    }, {
      key: "item.coverageKPI",
      fn: function(ref) {
        var item = ref.item;

        return [(item.coverageKPIEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'coverageKPI')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.coverageKPI) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.coverageKPI),
            callback: function($$v) {
              _vm.$set(item, "coverageKPI", $$v)
            },
            expression: "item.coverageKPI"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.currentProgress",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.currentProgress) + " %\n      ")])]
      }
    }, {
      key: "item.totalAchieved",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.totalAchieved) + " %\n      ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('viewInfluencers', item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          }
        }, [_vm._v("people")])], 1)], 1)]
      }
    }], null, true)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36804d80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/AOKReport/ReportTable.vue
// module id = 2077
// module chunks = 0